import { Mail } from "lucide-react";
import { MaskedLine, Reveal } from "../components/Motion";
import { Seo } from "./Seo";
import { SITE } from "../site";

const LegalPage = ({ title, eyebrow, updated, intro, sections, showContact = true, testId, description, path }) => {
    return (
        <>
            <Seo title={`${title} — SahiKhoj`} description={description} path={path || "/"} />
            <section className="hero-glow bg-ink pb-16 pt-40 text-cream sm:pb-20 lg:pt-48">
                <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
                    <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.24em] text-mist">
                        <span className="h-px w-10 bg-saffron" />
                        {eyebrow}
                    </p>
                    <h1 className="mt-7 max-w-4xl font-display text-4xl font-semibold leading-[1.06] tracking-tighter sm:text-5xl lg:text-6xl">
                        <MaskedLine delay={0.2}>{title}</MaskedLine>
                    </h1>
                    <p className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-mist/70">
                        Last updated: {updated}
                    </p>
                </div>
            </section>

            <section data-testid={testId} className="bg-cream py-20 sm:py-28">
                <div className="mx-auto max-w-3xl px-6 sm:px-8">
                    {intro && (
                        <Reveal>
                            <p className="font-display text-xl font-medium leading-relaxed tracking-tight text-ink sm:text-2xl">
                                {intro}
                            </p>
                        </Reveal>
                    )}
                    <div className="mt-12 space-y-12">
                        {sections.map(({ heading, body }, i) => (
                            <Reveal key={heading} delay={0.03}>
                                <section data-testid={`${testId}-section-${i + 1}`}>
                                    <div className="flex items-baseline gap-4">
                                        <span className="font-mono text-xs text-saffron">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <h2 className="font-display text-xl font-semibold tracking-tight text-ink sm:text-2xl">
                                            {heading}
                                        </h2>
                                    </div>
                                    <div className="mt-4 space-y-4 border-l border-ink/10 pl-6 sm:pl-8">
                                        {body.map((para, j) => (
                                            <p key={j} className="text-sm leading-relaxed text-smoke sm:text-base">
                                                {para}
                                            </p>
                                        ))}
                                    </div>
                                </section>
                            </Reveal>
                        ))}
                    </div>
                    {showContact && (
                        <Reveal delay={0.05}>
                            <div
                                data-testid={`${testId}-contact-block`}
                                className="mt-16 rounded-3xl border border-dashed border-saffron/50 bg-saffron-soft/50 p-8"
                            >
                                <span className="inline-flex items-center gap-2 rounded-full bg-saffron-soft px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-saffron">
                                    <Mail className="h-3.5 w-3.5" />
                                    Official support
                                </span>
                                <p className="mt-4 flex flex-wrap items-center gap-2 text-sm text-ink sm:text-base">
                                    <Mail className="h-4 w-4 shrink-0 text-saffron" />
                                    For questions about this page, write to us at
                                    <a href={`mailto:${SITE.supportEmail}`} className="font-semibold text-ink underline decoration-saffron/50 underline-offset-4 transition-colors hover:text-saffron">{SITE.supportEmail}</a>
                                </p>
                            </div>
                        </Reveal>
                    )}
                </div>
            </section>
        </>
    );
};

export default LegalPage;
